import { detialContract,deleteContract,updateContract,getaddressinfo,checkident } from "@/api/contract";
import printHtml from "@/utils/printHtml"
import moment from "moment"
import {message, Modal} from "ant-design-vue"
import {getAll as getAllbaoxiaotypes} from "@/api/baoxiaotype.js"



export default {
  props:['id'],
  data() {
    return {
      contractcontent: {},
	  baoxiaotypes:[],
      price:'',
	  worktype:{"1":"点工","2":"带班","3":"班组","4":"供应商"},
      priceName:{"1":"结算金额",'5':"本协议价格","2":"结算金额","3":"预支金额","4":"扫码登记","6":"报销金额","7":"材料预支金额","8":"材料领取单","9":"材料转运单","10":"工资明细单"},
    };
  },
  methods: {
	getweizhi(address){
		if(typeof address == "string"){
			address = JSON.parse(address)
		}	
		return address
	},
	getimgsrcs(urls){
		if(urls){
			let ret = urls.split(",")
			return ret
		}else{
			return []
		}
	},
	getcheckinfo(ret){
		if(ret.res == 1){
			return "身份证姓名一致"
		}
		if(ret.res == 2){
			if(ret.message){
				return ret.message
			}else{
				return "身份证姓名不一致"
			}
		}
	},
	identityChecks(){
		let {worktype,yi,yiIdCard,yiBanZhu,groupidcard} = this.contractcontent
		const hide = message.loading("正在检测中",200),
		msgerror =["乙方","班组"]
		if(worktype == 3){ //班组
			Promise.all([
				checkident({idcard:yiIdCard,name:yi}),
				checkident({idcard:groupidcard,name:yiBanZhu}),
			]).then(ret=>{
				hide()
				let str = ret.map((item,id)=>{
					let info = this.getcheckinfo(item)
					if(item.res == 1){
						return  <div style="margin-top:10px">{msgerror[id]}{info}</div>
					}else{
						return  <div style="margin-top:10px;color:red">{msgerror[id]}{info}</div>
					}
				})
				Modal.info({
					title:"提示信息",
					content:(
						<div>
							{str}
						</div>
					)
				})
			})
		}else{ //其他
			checkident({idcard:yiIdCard,name:yi}).then(ret=>{
				hide()
				let info = this.getcheckinfo(ret)
				let str = []
				if(ret.res == 1){
					str =  <div>乙方{info}</div>
				}else{
					str =  <div style="color:red">乙方{info}</div>
				}
				Modal.info({
					title:"提示信息",
					content:str
				})
			})
		}
	},
   //保存身份证号 临时功能
   saveinfo(){
       let {id,yiBanZhu,yiIdCard,worktype,groupidcard,yi,baoxiaotype,type } = this.contractcontent
       let parm = {id,worktype,yiIdCard,yi,type}
	   if(type == 6){
		   parm ={...parm,baoxiaotype}
	   }
       if(worktype ==3){
	       parm = {...parm,yiBanZhu,groupidcard}
       }
	   if(worktype == 1){
	       parm = {...parm,yiBanZhu}
	   }
       message.loading({content:"正在保存...",key:"saveinfo"})
       updateContract(parm).then(()=>{
           message.success({content:"保存成功",key:"saveinfo",duration:2})
		   this.$emit("saveCallback")
           this.price =""
       }).catch(err=>{
           console.log(err)
           message.error({content:"操作失败",key:"checkcontract",duration:2})
       })  
   },
   printcontract(){
        let newStr = document.getElementById("printdiv").innerHTML;
        printHtml(newStr)
   },
   goback(){
	   this.$emit("backfn")
   },
   confirmCheck(){
        if(!this.price&&this.contractcontent.type != 4){
           message.error({content:"请输入合同价格",duration:2})
            return;
        }
        let content = this.contractcontent.type == 4?"您确定审核通过": `您确定将合同价格设置为${this.price},审核通过吗？`
        this.$confirm({
            title:"操作确认提示",
            content,
            okText:"确定",
            cancelText:"取消",
            onOk:()=>{
                this.checkpass()
            }
        }) 
   },
   checkpass(){
      let {id,type } = this.contractcontent
      let price = this.price
       message.loading({content:"正在审核...",key:"checkcontract"})
       updateContract({id,price,status:"3",type,jiaDate:moment().format("YYYY年MM月DD日")}).then(()=>{
           message.success({content:"操作成功",key:"checkcontract",duration:2})
           this.$router.push({"name":"contractfinished"})
           this.price =""
       }).catch(err=>{
           console.log(err)
           message.error({content:"操作失败",key:"checkcontract",duration:2})
       }) 
   },
   confirmDel(){
       this.$confirm({
                title:"操作确认提示",
                content:"您确定要删除该合同？",
                okText:"确定",
                cancelText:"取消",
                onOk:()=>{
                    this.deletecon()
                }
        })
   },
   deletecon(){
       let {id } = this.contractcontent
       message.loading({content:"正在删除...",key:"delcontract"})
       deleteContract({id}).then(()=>{
           message.success({content:"删除成功",key:"delcontract",duration:2})
           this.$router.push({"name":"contractcheck"})
       }).catch(err=>{
           console.log(err)
           message.error({content:"删除失败",key:"delcontract",duration:2})
       }) 
   },
	getbaoxiaotypes(){
			getAllbaoxiaotypes().then(ret=>{
				if(ret.code == 0){
					let {data} = ret
					this.baoxiaotypes = data
				}
			})
		}
  },
  mounted() {
    detialContract({ id:this.id })
	.then(ret => {
		this.contractcontent = ret.ret;
		this.price = ret.ret.price;
		return ret.ret
	}).then(({address})=>{
		getaddressinfo(address).then(({ret})=>{
			this.contractcontent.address = ret.formatted_address
		})
	})
	.catch(err => {
		console.log(err);
	});
	this.getbaoxiaotypes()
  },
  components: {
  }
};